"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Wallet, Package, BarChart3, Tag, Flame, LineChart } from "lucide-react";
import { cn } from "@/lib/utils";
import { useFlags } from "@/lib/flags-context";

const TABS = [
  { href: "cashback", label: "Cashback", icon: Wallet, section: "cashback" },
  { href: "productos", label: "Productos", icon: Package, section: "products" },
  { href: "comparador", label: "Comparador", icon: BarChart3, section: "products" },
  { href: "historial-de-precios", label: "Historial", icon: LineChart, section: "products", feature: "products.priceHistory" },
  { href: "cupones", label: "Cupones", icon: Tag, section: "coupons" },
  { href: "ofertas", label: "Ofertas", icon: Flame, section: "community" },
] as const;

interface Props {
  basePath: string; // "/tienda/<slug>" o "/marca/<slug>"
}

export function StoreTabsNav({ basePath }: Props) {
  const pathname = usePathname() ?? "";
  const flags = useFlags();
  const visibleTabs = TABS.filter(
    (t) => flags[t.section] !== false && ("feature" in t ? flags[t.feature] !== false : true)
  );
  if (visibleTabs.length === 0) return null;

  return (
    <nav className="bg-background border rounded-2xl overflow-hidden">
      <div className="flex overflow-x-auto scrollbar-hide">
        {visibleTabs.map((t) => {
          const href = `${basePath}/${t.href}`;
          const active = pathname === href;
          const Icon = t.icon;
          return (
            <Link
              key={t.href}
              href={href}
              className={cn(
                "flex items-center gap-1.5 px-4 py-3 text-sm font-semibold whitespace-nowrap border-b-2 transition-colors flex-1 justify-center min-w-[110px]",
                active
                  ? "border-primary text-primary bg-primary/5"
                  : "border-transparent text-muted-foreground hover:text-foreground hover:bg-muted"
              )}
            >
              <Icon className="w-4 h-4" />
              {t.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
